/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Module for API Services

Author: Deimos Space UK

Version: 1.0
*/

import { toast } from 'react-toastify';
const SERVER_URL = process.env.REACT_APP_SERVER_URL



export const getPetition = async (url) => {
  let response = await fetch(SERVER_URL + url, {
    credentials: 'include',
  })
  let data = await response.json()
  return data
}

export const getImage = async (url) => {
  let response = await fetch(SERVER_URL + url, {
    credentials: 'include',
  })
  let data = await response.blob()
  return [data, response.ok]
}



export const postPetition = async (url, body) => {

  const options = {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: body
  };
  const data = fetch(SERVER_URL + url, {
    credentials: 'include',
    ...options
  })
  
    .then(response => response.json())
    .then(response => {
      if (response.messages) {
        toast.error('An error occurred while creating the mission, please, check the form ')
      }
      else{
        return response
      }
    })
    .then(response => {

      return response
    })
    .catch(err =>   toast.error('An error occurred while creating the mission, please, check the form '));

  if (data) {
    return data
  }
}





